import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

type RuleNames =
  | 'loaderBlock';

const PREFIX = 'Loader';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      loaderBlock: {
        marginTop: '200px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        '& .MuiCircularProgress-svg': {
          color: theme.lightGreen,
        },
      },
    }
  ),
  { name: PREFIX },
);
